// Format date for comparison headers
export const formatComparisonDate = (timestamp: Date | number) => {
  // Convert to Date if it's a number
  const date = typeof timestamp === 'number' ? new Date(timestamp) : timestamp;

  return {
    date: date.toLocaleDateString('en-US', { month: 'short', day: 'numeric' }),
    time: date.toLocaleTimeString('en-US', { hour: '2-digit', minute: '2-digit', hour12: false }),
  };
};

export function formatDateLabel(isoString: string) {
  const date = new Date(isoString);
  const pad = (n: number) => n.toString().padStart(2, '0');
  return (
    `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())} ` +
    `${pad(date.getHours())}:${pad(date.getMinutes())}`
  );
}
